<div class="mt-4 border cp-general-width-limit p-2 m-2">
	<canvas baseChart [data]="lineChartData" [options]="lineChartOptions" [type]="lineChartType"></canvas>
</div>

<!-- (chartHover)="chartHovered($event)"
    (chartClick)="chartClicked($event)" -->

<button type="button" class="btn btn-sm btn-outline-info" (click)="update()">
	update
</button>